import api from '../api-configuration';
export const getSayimDetails = async (countCode) => {
    try {
        const response = await api.post('/getInventoryCountDetails', {
            count_code: countCode.trim()
        });

        if (!response.data.success) {
            throw new Error('API yanıtı başarısız');
        }

        return response.data.data;
    } catch (error) {
        console.error('API çağrısı hatası:', error);
        let message = error.response.data.error || 'Sayım detayları alınamadı';
        throw new Error(message);
    }
}

export const getAddressesByZone = async (countCode, zoneId) => {
    try {
        const response = await api.post('/getInventoryCountAddressDetails', {
            count_code: countCode.trim().toUpperCase(),
            zone_id: zoneId
        });

        return response.data;
    } catch (error) {
        console.error('Adres bilgileri alınırken hata:', error);
        throw new Error('Adres bilgileri alınamadı');
    }
}

export const userGetLastScanAdress = async (user_id) => {

    return {
        kordinat: "A",
        yon: "A",
        sira: 1
    }
}

export const getAdresDetails = async (zone_id) => {

    return {
        addresses: [
            {
                kordinat: "A",
                yon: "A",
                sira: 1,
                kapasite: 3,
                scan_count: 1,
                last_scan_sase: "1234567890",
                fiziksel_sase_count: 2,
                is_finish: true

            },
            {
                kordinat: "A",
                yon: "A",
                sira: 2,
                kapasite: 3,
                scan_count: 1,
                last_scan_sase: "1234567890",
                fiziksel_sase_count: 0,
                is_finish: false
            },
            {
                kordinat: "A",
                yon: "A",
                sira: 3,
                kapasite: 3,
                scan_count: 0,
                last_scan_sase: null,
                fiziksel_sase_count: 0,
                is_finish: false
            }
        ]
    }
}

export const unAddressedScanChassis = async (chassisNo, countCode, userId) => {
    try {
        const response = await api.post('/unAddressedScanChassis', {
            chassis_no: chassisNo.trim().toUpperCase(),
            count_code: countCode.trim().toUpperCase(),
            user_id: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii'))
        });

        return response.data;
    } catch (error) {
        console.error('Adressiz sayım API hatası:', error);
        throw new Error('Şase okutma işlemi başarısız');
    }
}

export const addressedScanChassis = async (chassisNo, countCode, zoneId, addressCode, forceScan = false, skip = false) => {
    try {
        const response = await api.post('/addressedScanChassis', {
            count_code: countCode.trim().toUpperCase(),
            chassis_no: chassisNo.trim().toUpperCase(),
            zone_id: zoneId,
            address_code: addressCode,
            scanned_by: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
            force_scan: forceScan,
            skip: skip
        });

        return response.data;
    } catch (error) {
        console.error('Adresli sayım API hatası:', error);
        throw new Error('Şase okutma işlemi başarısız');
    }
}

export const lastScanAddressByUser = async (countCode, userId) => {
    try {
        const response = await api.post('/lastScanAddressByUser', {
            count_code: countCode.trim().toUpperCase(),
            user_id: userId
        });

        return response.data;
    } catch (error) {
        console.error('Son tarama adresi API hatası:', error);
        throw new Error('Son tarama adresi alınamadı');
    }
}

export const resetAddress = async (address, countCode, zoneId) => {
    try {
        const response = await api.post('/resetAddress', {
            address: address,
            count_code: countCode.trim().toUpperCase(),
            zone_id: zoneId
        });

        return response.data;
    } catch (error) {
        console.error('Adres reset API hatası:', error);
        throw new Error('Adres reset işlemi başarısız');
    }
}

